import React from 'react';
import PropTypes from 'prop-types';

import { getStatus } from '../../../utils';
import AddAssignee from './addAssignee';
import AddBan from './addBan';
import FormSummaryRow from '../../../../../form/formSummaryRow';
import { SummaryRow, SummaryCol } from '../css';

const OrderHeader = ({ orderData, userRights }) => {
  const {
    orderId,
    iotCompanyName,
    iotProductConsoleOrderId,
    iotShippmentTrackingNumber,
    status
  } = orderData;

  const { finalStatus } = getStatus({ status });

  return (
    <>
      <FormSummaryRow key="orderId" label="Order Id" value={orderId} />
      <FormSummaryRow
        key="businessName"
        label="Business Name"
        value={iotCompanyName}
      />
      <FormSummaryRow key="status" label="Status" value={finalStatus} />
      <SummaryRow>
        <SummaryCol>Assignee</SummaryCol>
        <AddAssignee orderData={orderData} userRights={userRights} />
      </SummaryRow>
      <SummaryRow>
        <SummaryCol>BAN Number</SummaryCol>
        <AddBan orderData={orderData} userRights={userRights} />
      </SummaryRow>
      <FormSummaryRow
        key="iotProductConsoleOrderId"
        label="Product console order ID"
        value={iotProductConsoleOrderId || 'n/a'}
      />
      <FormSummaryRow
        key="iotShippmentTrackingNumber"
        label="Shipping tracking #"
        value={iotShippmentTrackingNumber || 'n/a'}
      />
    </>
  );
};

OrderHeader.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  userRights: PropTypes.objectOf(PropTypes.object).isRequired
};

export default OrderHeader;
